import React, { memo, useEffect, useCallback } from "react";

const filterRef = React.createRef();

import Category from "./Category";
import Retailers from "./Retailers";
import Shipping from "./Shipping";
import Brands from "./Brands";
import Options from "./Options";
import Price from "./Price";

function Filters(props) {
  const { styles } = props;
  // scroll lister start
  const addListerner = useCallback(() => {
    // forward scroll Check
    // if (
    // 	!filterRef.current?.scrollVal ||
    // 	filterRef.current?.scrollVal < window.scrollY
    // ) {
    if (filterRef.current) filterRef.current.scrollVal = window?.scrollY || 0;
    if (filterRef?.current?.clientHeight) {
      if (window.innerHeight < filterRef.current.clientHeight) {
        filterRef.current.style.position = "sticky";
        filterRef.current.style.top = `${
          filterRef.current.clientHeight > window.innerHeight
            ? -filterRef.current.clientHeight + window.innerHeight
            : 100
        }px`;
      } else {
        filterRef.current.style.position = "sticky";
        filterRef.current.style.top = "100px";
      }
    }
    //} else {
    // backward scroll Check
    // if (filterRef.current) filterRef.current.scrollVal = window?.scrollY || 0;
    // if (window.innerHeight > filterRef.current.clientHeight) {
    // 	filterRef.current.style.position = 'sticky';
    // 	filterRef.current.style.top = `${
    // 		filterRef.current.clientHeight > window.innerHeight
    // 			? -filterRef.current.clientHeight + window.innerHeight
    // 			: 100
    // 	}px`;
    // } else {
    // 	filterRef.current.style.position = 'sticky';
    // 	filterRef.current.style.top = '100px';
    // }
    //}
  }, []);

  const removeListerner = useCallback(() => {
    document.removeEventListener("scroll", addListerner);
    filterRef.current = null;
  }, [addListerner]);
  // scroll lister end

  useEffect(() => {
    document.addEventListener("scroll", addListerner);
    return () => {
      removeListerner();
    };
  }, [addListerner, removeListerner]);

  return (
    <div
      className={`${styles.listingFilter} borderBox`}
      ref={filterRef}
      style={{ position: "relative", top: "0px" }}
    >
      <div id="accordion">
        <Category {...props} />
        <Price {...props} />
        {!props.store && <Shipping {...props} />}
        {!props.isAuction && (
          <>
            {!props.store && <Retailers {...props} />}
            {!props.brand && <Brands {...props} />}
            {props.category && <Options {...props} />}
          </>
        )}
      </div>
    </div>
  );
}

export default memo(Filters);
